import React, { Component } from "react";
import styled from "styled-components";

import NavItem from "./NavItem";

const TabList = styled.ul`
  list-style: none;
  display: flex;
  justify-content: space-between;
  padding: 0;
  z-index: 10;
  background: white;
  box-shadow: 0 2px 40px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  position: sticky;
  top: 0;
  ::-webkit-scrollbar {
    display: none;
  }
  @media screen and (max-width: 48em) {
    overflow-x: scroll;
  }
`;

const CountryNavigator = ({ countries, currentId }) => {
  const renderTabList = () => {
    return countries.map(country => (
      <NavItem
        key={country.id}
        {...country}
        isActive={country.id === currentId}
      />
    ));
  };

  return <TabList>{renderTabList()}</TabList>;
};

export default CountryNavigator;



// WEBPACK FOOTER //
// ./src/components/CountryNavigator/index.js